// de_pms_revenue.ts
// Tłumaczenia dla PMS.Revenue.tsx

export const dePmsRevenue = {

  title: "Revenue Management",

  // ── Sekcje ───────────────────────────────────────────────────────────────
  sections: {
    forecast:          "Prognose und Erkenntnisse",
    demandCalendar:    "Nachfragekalender",
    activeRestrictions:"Aktive Restriktionen",
    eventsImpact:      "Veranstaltungseinfluss",
    conflictEngine:    "Konflikt-Engine",
    governance:        "Governance",
    derivedRules:      "Abgeleitete Regeln",
    groupsBlocks:      "Gruppen und Kontingente",
  },

  // ── Etykiety KPI / tabeli ─────────────────────────────────────────────────
  labels: {
    adrGap:           "ADR-Lücke",
    cancellationRate: "Stornierungsrate",
    corporatePickup:  "Corporate-Pickup",
    behindPace:       "Hinter Plan",
    onPace:           "Im Plan",
    base:             "Basis",
    active:           "Aktiv",
    corporate:        "Corporate",
    event:            "Veranstaltung",
    forecast:         "Prognose",
    critical:         "Kritisch",
  },

} as const;

export default dePmsRevenue;
